/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import Grid from "@mui/material/Grid";
import { GlobalStyles, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import MDBox from "components/MDBox";
import {
    CartesianGrid,
    XAxis,
    YAxis,
    Legend,
    Tooltip,
    ResponsiveContainer,
} from "recharts";
import { LineChart, Line } from "recharts";
import { useMaterialUIController } from "context";
import { parseValue } from "utils/Constant";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDTypography from "components/MDTypography";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import Card from "@mui/material/Card";
import { Button } from "antd";
import { StopOutlined } from "@ant-design/icons";
import { List } from "antd";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import DownloadIcon from "@mui/icons-material/Download";
import "./somestyle.css";

import { useSnackbar } from "notistack";
import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    MinusCircleOutlined,
    SyncOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
import PopAddStopSession from "./PopAddStopSession";
import { connect } from "react-redux";

import InfoCard from "layouts/location_mgmt/components/Infocard";
import { handleSignout } from "utils/Logout";
import { getDecodedUserData } from "utils/Constant";

const timeAgo = (timestamp) => {
    const now = new Date();
    const timeDifference = Math.floor((now - new Date(timestamp)) / 1000 / 60);
    if (timeDifference === 0) {
        return "just updated";
    } else if (timeDifference === 1) {
        return "updated 1 min ago";
    } else {
        return `updated ${timeDifference} mins ago`;
    }
};

function ViewTransaction() {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const location = useLocation();
    const [content, setContent] = useState([]);
    const [isDisabled2, setIsDisabled2] = useState(false);
    const [scaledData, setScaledData] = useState([]);
    const [timestamp, setTimestamp] = useState(new Date());

    useEffect(() => { }, []);
    const [metadata, setMetadata] = useState([]);
    const [threePhase, setThreePhase] = useState(false);
    const [currentData, setCurrentData] = useState({
        labels: [],
        datasets: { label: "", data: [] },
    });
    const [powerData, setPowerData] = useState({
        labels: [],
        datasets: { label: "", data: [] },
    });
    const [socData, setSocData] = useState({
        labels: [],
        datasets: { label: "", data: [] },
    });
    const [energyData, setEnergyData] = useState({
        labels: [],
        datasets: { label: "", data: [] },
    });

    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const convertToMinute = () => {
        const minutes = Math.floor(content?.sessionWaitTime / 60);
        const seconds = content?.sessionWaitTime % 60;
        const formattedTime = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")} mins`;
        return formattedTime;
    };

    const parseEnergyTOKWh = (value) => {
        if (!value || typeof value !== "string") return 0;

        const [numStr, unit] = value.trim().split(/\s+/);
        const num = parseFloat(numStr);

        if (!Number.isFinite(num)) return 0;

        // Normalize everything to kWh
        if (unit?.toLowerCase() === "wh") {
            return num / 1000; // Wh → kWh
        }

        if (unit?.toLowerCase() === "kwh") {
            return num; // already kWh
        }

        // fallback (unknown unit)
        return num;
    };


    const fetchSession = async () => {
        await axios
            .get(process.env.REACT_APP_BASEURL + `session/${location.state?._id}`, {
                withCredentials: true,
            })
            .then((response) => {
                if (response.data.success) {
                    const session = response.data.data;

                    if (session) {
                        const metadata = session.metadata || [];

                        const firstEntry =
                            metadata[0]?.values?.["Energy.Active.Import.Register"];
                        const lastEntry =
                            metadata[metadata.length - 1]?.values?.[
                            "Energy.Active.Import.Register"
                            ];

                        const firstEnergyKWh = parseEnergyTOKWh(firstEntry);
                        const lastEnergyKWh = parseEnergyTOKWh(lastEntry);

                        const energyConsumed =
                            lastEnergyKWh && firstEnergyKWh
                                ? lastEnergyKWh - firstEnergyKWh
                                : 0;

                        const userPhone = session.userPhone || "";

                        const updatedSession = {
                            ...session,
                            status:
                                session.status === "Started"
                                    ? "Paid"
                                    : session.status === "Stopped"
                                        ? "Completed"
                                        : session.status === "Completed"
                                            ? "Completed"
                                            : session.status,
                            energy_disp1: `${(energyConsumed).toFixed(2)} kWh`,
                            userPhone: userPhone,
                        };

                        setContent(updatedSession);

                        const metadataResponse = updatedSession?.metadata;

                        const transformedData = metadataResponse.map((entry) => {
                            const v = entry.values;

                            const energyKWh = parseEnergyTOKWh(
                                v["Energy.Active.Import.Register"]
                            );

                            const powerW = parseValue(v["Power.Active.Import"]);

                            return {
                                timestamp: new Date(entry.timestamp).toLocaleTimeString(),

                                //  Always kWh delta
                                energy: (energyKWh - firstEnergyKWh),

                                // power stays same
                                power: powerW / 1000,

                                voltage: parseValue(v["Voltage"]),
                                current: parseValue(v["Current.Import"]),
                                temperature: parseValue(v["Temperature"]),
                                frequency: parseValue(v["Frequency"]),
                                SoC: parseValue(v["SoC"]),
                            };
                        });

                        const metricsToNormalize = [
                            "energy",
                            "power",
                            "voltage",
                            "current",
                            "temperature",
                            "frequency",
                        ];

                        const ranges = {};
                        metricsToNormalize.forEach((key) => {
                            const vals = transformedData.map(d => d[key]).filter(Number.isFinite);
                            ranges[key] = {
                                min: Math.min(...vals),
                                max: Math.max(...vals),
                            };
                        });

                        const normalizedData = transformedData.map((d) => {
                            const o = { ...d };

                            metricsToNormalize.forEach((key) => {
                                const { min, max } = ranges[key];
                                o[`${key}_norm`] =
                                    max !== min ? ((d[key] - min) / (max - min)) * 100 : 0;
                            });

                            // SOC remains real %
                            o.SoC_norm = d.SoC;

                            return o;
                        });

                        setMetadata(transformedData);   // real values (Excel, tooltip)
                        setScaledData(normalizedData);  // chart-friendly


                        /* =========================
                           SET STATE ONCE
                        ========================= */

                        setMetadata(transformedData);     // raw values (for Excel, tooltips)
                        setScaledData(normalizedData);    // normalized values (for chart)
                        setPowerData({
                            labels: transformedData.map((item) => item.timestamp),
                            datasets: {
                                label: "Power (kW)",
                                data: transformedData.map((item) => item.power),
                                borderColor: "green",
                                backgroundColor: "rgba(0, 255, 0, 0.1)",
                                fill: true,
                                tension: 0.4,
                            },
                        });
                        setCurrentData({
                            labels: transformedData.map((item) => item.timestamp),
                            datasets: {
                                label: "Current (A)",
                                data: transformedData.map((item) => item.current),
                                borderColor: "green",
                                backgroundColor: "rgba(0, 255, 0, 0.1)",
                                fill: true,
                                tension: 0.4,
                            },
                        });
                        setSocData({
                            labels: transformedData.map((item) => item.timestamp),
                            datasets: {
                                label: "SOC (%)",
                                data: transformedData.map((item) => item.SoC),
                                borderColor: "green",
                                backgroundColor: "rgba(0, 255, 0, 0.1)",
                                fill: true,
                                tension: 0.4,
                            },
                        });
                        setEnergyData({
                            labels: transformedData.map((item) => item.timestamp),
                            datasets: {
                                label: "Energy (KWh)",
                                data: transformedData.map((item) =>
                                    Number(item.energy.toFixed(2))
                                ),
                                borderColor: "green",
                                backgroundColor: "rgba(0, 255, 0, 0.1)",
                                fill: true,
                                tension: 0.4,
                            },
                        });
                    }
                } else {
                    enqueueSnackbar(response.data.message, { variant: "error" });
                }
            })
            .catch((error) => {
                console.error(error);
                if (error?.response?.status === 401) {
                    handleSignout();
                }
            });
    };
    useEffect(() => {
        if (getDecodedUserData()?.login_status !== "true") {
            navigate("/sign-in");
        }

        setTimestamp(new Date());
        fetchSession();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const lastUpdated =
        metadata.length > 0 ? metadata[metadata.length - 1].timestamp : null;

    const getValues1 = () => {
        return {
            charger_id: content?.chargerId || "",
            connector_id: content?.connectorId || "",
            session_id: content?.vehicleId || "",
            reason: "",
        };
    };
    const handleDownloadExcelFromMetadata = async () => {
        if (!metadata || !Array.isArray(metadata) || metadata.length === 0) {
            console.error("No metadata available!");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("Metadata Readings");

        const keys = Object.keys(metadata[0]);

        const headerRow = sheet.addRow(keys);
        headerRow.font = { bold: true, size: 14 };
        headerRow.alignment = { horizontal: "center", vertical: "middle" };
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFFF00" },
            };
        });

        metadata.forEach((entry) => {
            const row = keys.map((key) => entry[key] ?? "");
            sheet.addRow(row);
        });

        sheet.eachRow((row) => {
            row.eachCell((cell) => {
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.border = {
                    top: { style: "thin" },
                    bottom: { style: "thin" },
                    left: { style: "thin" },
                    right: { style: "thin" },
                };
            });
        });

        sheet.columns.forEach((column) => {
            column.width = 22;
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "metadata_readings.xlsx");
    };

    console.log("Content", content);
    const [values1, setValues1] = useState(getValues1);
    useEffect(() => {
        if (content?.chargerId) {
            setValues1((prevValues) => ({
                ...prevValues,
                charger_id: content.chargerId,
                session_id: content._id,
            }));
        }
    }, [content]);

    const CustomTooltip = ({ active, payload, label }) => {
        if (!active || !payload || !payload.length) return null;

        // filter out invalid values
        const validItems = payload.filter((p) => {
            const key = p.dataKey.replace("_norm", "");
            const value = p.payload[key];

            return (
                value !== null &&
                value !== undefined &&
                !Number.isNaN(value) &&
                value !== 0
            );
        });

        // if nothing valid, don’t show tooltip at all
        if (validItems.length === 0) return null;

        return (
            <div
                style={{
                    background: "#fff",
                    padding: "10px",
                    borderRadius: "8px",
                    fontSize: "12px",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                }}
            >
                <strong style={{ display: "block", marginBottom: "6px" }}>
                    {label}
                </strong>

                {validItems.map((p) => {
                    const key = p.dataKey.replace("_norm", "");
                    const value = p.payload[key];
                    const formattedValue =
                        key === "energy"
                            ? value.toFixed(2)
                            : value;

                    return (
                        <div key={p.dataKey} style={{ color: p.color }}>
                            {p.name}: {formattedValue}
                        </div>
                    );
                })}
            </div>
        );
    };

    const LINE_COLORS = {
        energy: "#6366F1",      // Indigo
        power: "#22C55E",       // Green
        voltage: "#F59E0B",     // Amber
        current: "#F97316",     // Orange
        temperature: "#EF4444",// Red
        frequency: "#EC4899",  // Pink
        SoC: "#3B82F6",         // Blue
    };



    const hasNonZeroData = (key) =>
        scaledData.some(
            (d) => Number.isFinite(d[key]) && d[key] !== 0
        );

    const chartLines = [
        { key: "energy", label: "Energy (kWh)", color: LINE_COLORS.energy },
        { key: "power", label: "Power (kW)", color: LINE_COLORS.power },
        { key: "current", label: "Current (A)", color: LINE_COLORS.current },
        { key: "voltage", label: "Voltage (V)", color: LINE_COLORS.voltage },
        { key: "temperature", label: "Temperature (°C)", color: LINE_COLORS.temperature },
        { key: "frequency", label: "Frequency (Hz)", color: LINE_COLORS.frequency },
        { key: "SoC", label: "SOC (%)", color: LINE_COLORS.SoC },
    ];
    const threePhaseLines = [
        // Voltage
        {
            key: "voltage_norm",
            label: "Voltage L1 (V)",
            color: "#F59E0B",
        },
        {
            key: "voltageL2_norm",
            label: "Voltage L2 (V)",
            color: "#FBBF24",
        },
        {
            key: "voltageL3_norm",
            label: "Voltage L3 (V)",
            color: "#FCD34D",
        },

        // Current
        {
            key: "current_norm",
            label: "Current L1 (A)",
            color: "#F97316",
        },
        {
            key: "currentL2_norm",
            label: "Current L2 (A)",
            color: "#FB923C",
        },
        {
            key: "currentL3_norm",
            label: "Current L3 (A)",
            color: "#FDBA74",
        },
    ];

    const metricKeys = (threePhase ? threePhaseLines : chartLines).map(l => l.key);

    const maxY = Math.max(
        ...metadata.map(row =>
            Math.max(...metricKeys.map(k => Number(row[k] || 0)))
        )
    );

    const baseCardSX = (darkMode) => ({
        boxShadow: darkMode
            ? "0 4px 12px rgba(0,0,0,0.3)"
            : "0 4px 12px rgba(0,0,0,0.1)",
        borderRadius: "16px",
        border: "1px solid",
        borderColor: darkMode
            ? "rgba(255,255,255,0.1)"
            : "rgba(0,0,0,0.08)",
    });


    return (

        <DashboardLayout>

            <DashboardNavbar absolute isMini />
            <PopAddStopSession
                isDialog={isDisabled2}
                onClose={setIsDisabled2}
                value={values1}
            />
            <MDBox pt={8}>
                <Grid container spacing={3}>
                    {/* Header Section */}
                    {/* <Grid item xs={12} sm={8}> */}
                    <Grid item xs={12}>
                        <Card sx={{ ...baseCardSX(darkMode), mb: 3 }}>
                            <MDBox p={3}>
                                <Grid container spacing={3} alignItems="center">
                                    <Grid item xs={12} md={8}>
                                        {/* Status */}
                                        <MDBox mb={1.5}>
                                            {content?.status === "Paid" && (
                                                <Tag icon={<CheckCircleOutlined />} color="blue">Active</Tag>
                                            )}
                                            {content?.status === "Unpaid" && (
                                                <Tag icon={<CloseCircleOutlined />} color="error">Unpaid</Tag>
                                            )}
                                            {content?.status === "Completed" && (
                                                <Tag icon={<CheckCircleOutlined />} color="success">Completed</Tag>
                                            )}
                                        </MDBox>

                                        <MDTypography variant="h4" fontWeight="bold">
                                            Charger ID : {content?.chargerId} - {content?.connectorId}
                                        </MDTypography>

                                        <MDTypography variant="body1" sx={{ opacity: 0.8 }}>
                                            {location?.state?.chargerName}
                                        </MDTypography>

                                        <MDTypography variant="body2" sx={{ opacity: 0.7 }}>
                                            Session ID : {content?._id}
                                        </MDTypography>

                                        <MDTypography variant="body2" sx={{ opacity: 0.6 }}>
                                            {content?.chargerLocation?.locationName} |{" "}
                                            {content?.chargerLocation?.city}
                                        </MDTypography>
                                    </Grid>

                                    <Grid item xs={12} md={4} sx={{ textAlign: { xs: "start", md: "end" } }}>
                                        {content?.status === "Paid" && (
                                            <Button
                                                type="primary"
                                                danger
                                                icon={<StopOutlined />}
                                                size="large"
                                                onClick={() => setIsDisabled2(true)}
                                            >
                                                Stop Session
                                            </Button>
                                        )}
                                    </Grid>
                                </Grid>
                            </MDBox>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={3} alignItems="stretch" pb={4}>
                            {/* LEFT SIDE — 2x2 InfoCard Grid */}
                            {/* LEFT SIDE — Info Cards (SEPARATE CARD, WIDER) */}
                            <Grid item xs={12} md={8}>
                                <Card
                                    sx={{
                                        ...baseCardSX(darkMode),
                                        height: "100%"
                                    }}
                                >
                                    <MDBox
                                        px={2.5}
                                        py={8}
                                        height="100%"
                                    >
                                        <Grid
                                            container
                                            rowSpacing={1.5}
                                            columnSpacing={2}
                                        >
                                            <Grid item xs={6}>
                                                <InfoCard value={content?.duration} label="Duration" />
                                            </Grid>

                                            <Grid item xs={6}>
                                                <InfoCard
                                                    value={content?.energy_disp1}
                                                    label="Energy Consumed"
                                                />
                                            </Grid>

                                            <Grid item xs={6}>
                                                <InfoCard
                                                    value={content?.co2Saved}
                                                    label="CO2 Saved"
                                                />
                                            </Grid>

                                            <Grid item xs={6}>
                                                <InfoCard
                                                    value={content?.userPhone || "—"}
                                                    label="Driver ID"
                                                />
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                </Card>
                            </Grid>



                            {/* RIGHT SIDE — Session Meta Information (SEPARATE CARD) */}
                            <Grid item xs={12} md={4}>

                                <Card
                                    sx={{
                                        ...baseCardSX(darkMode),
                                        height: "100%",
                                    }}
                                >
                                    <MDBox
                                        p={3}
                                        display="flex"
                                        flexDirection="column"
                                        height="100%"
                                        textAlign="right"
                                    >
                                        <MDTypography variant="h5" fontWeight="bold" mb={2}>
                                            Session Meta Information
                                        </MDTypography>

                                        <MDBox mb={2}>
                                            <MDTypography
                                                variant="button"
                                                fontWeight="medium"
                                                sx={{ opacity: 0.7 }}
                                            >
                                                Started By
                                            </MDTypography>

                                            <MDTypography variant="h6" fontWeight="medium">
                                                {content?.startCreatedBy || "—"}
                                            </MDTypography>

                                            <MDTypography variant="body2" sx={{ opacity: 0.6 }}>
                                                {content?.startReason || "—"}
                                            </MDTypography>
                                        </MDBox>
                                        <MDBox
                                            my={1.5}
                                            sx={{
                                                borderTop: "1px dashed",
                                                borderColor: darkMode
                                                    ? "rgba(255,255,255,0.15)"
                                                    : "rgba(0,0,0,0.12)",
                                            }}
                                        />

                                        {/* Stopped By */}
                                        <MDBox mb={2}>
                                            <MDTypography
                                                variant="button"
                                                fontWeight="medium"
                                                sx={{ opacity: 0.7 }}
                                            >
                                                Stopped By
                                            </MDTypography>

                                            <MDTypography variant="h6" fontWeight="medium">
                                                {content?.stopCreatedBy || "N/A"}
                                            </MDTypography>

                                            <MDTypography variant="body2" sx={{ opacity: 0.6 }}>
                                                {content?.stopReason || "N/A"}
                                            </MDTypography>
                                        </MDBox>

                                        {/* Push button to bottom */}
                                        <MDBox flexGrow={1} />

                                        {/* Bottom-right aligned button */}
                                        <MDBox display="flex" justifyContent="flex-end">
                                            <Button
                                                type="primary"
                                                icon={<DownloadIcon />}
                                                size="middle"
                                                style={{
                                                    backgroundColor: "#5cb460",
                                                    borderRadius: "8px",
                                                    paddingInline: "20px",
                                                }}

                                                onClick={handleDownloadExcelFromMetadata}
                                            >
                                                Download Report
                                            </Button>
                                        </MDBox>
                                    </MDBox>
                                </Card>
                            </Grid>

                        </Grid>
                    </Grid>

                </Grid>

                <Card>
                    <MDBox p={3}>
                        <MDTypography variant="h6" mb={2}>
                            Session Information
                        </MDTypography>
                        <ResponsiveContainer width="100%" height={300}>
                            <LineChart
                                data={scaledData}
                                margin={{
                                    right: 20,
                                    left: 20,
                                }}
                            >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis
                                    dataKey="timestamp"
                                    tick={{
                                        fontSize: 11,
                                        fill: "#9e9e9e", // optional, subtle gray
                                    }}
                                    angle={-35}
                                    textAnchor="end"
                                    height={50}
                                />

                                {/* Energy / Power */}
                                <YAxis
                                    tick={{ fontSize: 11 }}
                                    domain={[0, 400]}
                                    tickFormatter={(v) => `${v}`}
                                    padding={{ top: 20 }}
                                />

                                <Tooltip content={<CustomTooltip />} />
                                <Legend
                                    wrapperStyle={{
                                        fontSize: "16px",
                                        lineHeight: "16px",
                                        opacity: 0.85,
                                        paddingTop: "1rem"
                                    }}
                                />

                                {(threePhase ? threePhaseLines : chartLines).map(
                                    ({ key, label, color }) =>
                                        hasNonZeroData(key) && (
                                            <Line
                                                key={key}
                                                type="monotone"
                                                dataKey={key}
                                                name={label}
                                                stroke={color}
                                                strokeWidth={2.5}
                                                dot={{ r: 3 }}
                                                activeDot={{ r: 6 }}
                                            />
                                        )
                                )}



                            </LineChart>
                        </ResponsiveContainer>
                    </MDBox>
                </Card>
                <MDBox mt={8}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <MDBox mb={3}>
                                <ReportsLineChart
                                    color="info"
                                    title="Energy Dispersed (Wh)"
                                    description="Total energy dispersed in watt-hours over a given period."
                                    date={
                                        lastUpdated ? `${timeAgo(timestamp)}` : "No data available"
                                    }
                                    chart={energyData}
                                />
                            </MDBox>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <MDBox mb={3}>
                                <ReportsLineChart
                                    color="success"
                                    title="Power (kW)"
                                    description="Power consumption in kilowatts over a specified time period."
                                    date={
                                        lastUpdated ? `${timeAgo(timestamp)}` : "No data available"
                                    }
                                    chart={powerData}
                                />
                            </MDBox>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <MDBox mb={3}>
                                <ReportsLineChart
                                    color="dark"
                                    title="Current (A)"
                                    description="Current (amperage) values recorded over a designated time period."
                                    date={
                                        lastUpdated ? `${timeAgo(timestamp)}` : "No data available"
                                    }
                                    chart={currentData}
                                />
                            </MDBox>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <MDBox mb={3}>
                                <ReportsLineChart
                                    color="primary"
                                    title="State of Charge (%)"
                                    description="State of charge of the vehicle."
                                    date={
                                        lastUpdated ? `${timeAgo(timestamp)}` : "No data available"
                                    }
                                    chart={socData}
                                />
                            </MDBox>
                        </Grid>
                    </Grid>
                </MDBox>
            </MDBox>
        </DashboardLayout>
    );
}

export default ViewTransaction;
